import { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMyPlan, MyPlanResponse } from '@sentara-health/sentara-api-hooks-core';
import { errorhandler } from 'common';
import { Table, Loader } from '@sentara-health/optimahealth_web';
import { GlobalContext } from 'context';

function MemberDetails() {
  //Initialize translation hook
  const { t } = useTranslation();
  const [loading, setLoading] = useState<any>(false);
  const { getFeature } = useContext(GlobalContext);

  // Initialize MyPlanType hook and state for response data
  const { MyPlanType } = useMyPlan();
  const [myPlan, setMyPlan] = useState<MyPlanResponse>();
  const hasInitialized = useRef(false);

  // Fetch MyPlanType data on component mount
  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      const asyncCall = async () => {
        setLoading(true);
        const result = await MyPlanType();
        if (result?.errorCode) {
          errorhandler(result?.errorCode);
        } else if (result?.data) {
          setMyPlan(result.data);
        }
        setLoading(false);
      };
      asyncCall();
    }
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="table-responsive overflow-auto">
        <Table
          className="no-header-table"
          data-testid="memberDetailsTable"
          rows={[
            [
              {
                text: (
                  <span data-testid="memberName">
                    {t('common.memberName')}:
                  </span>
                ),
              },
              {
                text: (
                  <span data-testid="MemberNameValue">
                    {myPlan?.memberName}
                  </span>
                ),
              },
            ],
            [
              {
                text: (
                  <span data-testid="memberId">
                    {t('common.memberId')}:
                  </span>
                ),
              },
              {
                text: (
                  <span data-testid="memberIdValue">{myPlan?.memberId}</span>
                ),
              },
            ],
            [
              {
                text: (
                  <span data-testid="memberDob">
                    {t('common.dateOfBirth')}:
                  </span>
                ),
              },
              {
                text: (
                  <span data-testid="memberDobValue">
                    {myPlan?.memberDob.split(' ')[0]}
                  </span>
                ),
              },
            ],
            [
              {
                text: (
                  <span data-testid="effectiveDate">
                    {myPlan?.enrollmentCode === 'D'
                      ? t('yourPlan.disenrolledDate')
                      : t('common.effectiveDate')}
                    {':'}
                  </span>
                ),
              },
              {
                text: (
                  <span data-testid="effectiveDateValue">
                    {myPlan?.enrollmentCode === 'D'
                      ? myPlan?.enrolledDate.split(' ')[0]
                      : myPlan?.effectiveDate.split(' ')[0]}
                  </span>
                ),
              },
            ],
            getFeature?.ProfilePCP && myPlan?.pcpName.trim() !== ''
              ? [
                {
                  text: (
                    <span data-testid="pcpName">
                      {t('yourPlan.primaryCareProvider')}
                    </span>
                  ),
                },
                {
                  text: (
                    <span data-testid="pcpNameValue">{myPlan?.pcpName}</span>
                  ),
                },
              ]
              : [],
            getFeature?.ProfilePCP && myPlan?.pcpEffectiveaDate.trim() !== ''
              ? [
                {
                  text: (
                    <span data-testid="pcpEffectiveaDate">
                      {t('yourPlan.pCPEffectiveDate')}
                    </span>
                  ),
                },
                {
                  text: (
                    <span data-testid="pcpEffectiveaDateValue">
                      {myPlan?.pcpEffectiveaDate.split(' ')[0]}
                    </span>
                  ),
                },
              ]
              : [],
          ]}
        />
      </div>
    </>
  );
}

export default MemberDetails;
